import { PaginatedResponse } from '@/core/models/PaginatedResponse';
import { Team } from '@nxtpeople/nxt-vue-library';
import { LocationQuery } from 'vue-router';
import teamService from './team.service';

const state = {
   teamsOverview: null,
};

const getters = {
   teamsOverview(state: any) {
      return state.teamsOverview;
   },
   teams(state: any) {
      return state.teamsOverview ? state.teamsOverview.data : [];
   },
};

const mutations = {
   setTeamOverview(state: any, teamsOverview: PaginatedResponse<Team>) {
      state.teamsOverview = teamsOverview;
   },
};

const actions = {
   async getTeams({ commit }: any, query: any) {
      return await teamService.getTeams(query).then((response) => {
         commit('setTeamOverview', response);
         return response;
      });
   },
   async searchTeams(context: any, query?: LocationQuery) {
      return await teamService.getTeams({ ...query, per_page: 9999 }).then((response) => response.data);
   },
   async getTeam(context: any, payload: { teamId: number; query?: LocationQuery }) {
      return await teamService.getTeam(payload.teamId, payload.query);
   },
};

export default { namespaced: true, state, getters, mutations, actions };
